import { arrayToObjectCovert } from '../../../../services/commonService';

const handleFetchAgenciesFulfilled = (state, action) => {
  state.status = 'succeeded';
  state.agencies = arrayToObjectCovert(action.payload.data);
  state.agenciesOrder = action.payload.data.map(agency => agency.id);
  state.currentPage = action.payload.current_page;
  state.perPage = action.payload.limit;
  state.totalPages = action.payload.total_pages;
  state.totalAgencies = action.payload.total_agency_count;
  state.lastUpdated = action.payload.last_updated;
  state.message = action.payload.message;
};

const handleFetchMappingAgenciesFulfilled = (state, action) => {
  state.status = 'succeeded';
  state.mappingAgencies = action.payload.data;
  state.message = action.payload.message;
};

const handleFetchActiveAgenciesFulfilled = (state, action) => {
  state.status = 'succeeded';
  state.activeAgencies = action.payload.data;
  state.message = action.payload.message;
};

const handleDeleteAgencyFulfilled = (state, action) => {
  state.status = 'succeeded';
  const agencyId = action.payload.data.id;
  if (state.agencies && state.agencies[agencyId]) {
    delete state.agencies[agencyId];
    state.agenciesOrder = state.agenciesOrder.filter(agency => agency !== agencyId);
  }
  state.message = action.payload.message;
};

const handleAddAgencyFulfilled = (state, action) => {
  state.status = 'succeeded';
  const agencyId = action.payload.data.id;
  if (!state.agencies[agencyId]) {
    state.agencies[agencyId] = [];
  }
  state.agencies[agencyId].push(action.payload.data);
  state.message = action.payload.message;
};

const handleFetchAgencyByIdFulfilled = (state, action) => {
  state.status = 'succeeded';
  state.currentAgency = action.payload.data;
  state.currentAgencyBranches = action.payload.data.branch_data;
};

const handleUpdateAgencyFulfilled = (state, action) => {
  state.status = 'succeeded';
  state.agencies[action.payload.data.id] = action.payload.data;
  state.currentAgencyBranches = action.payload.data.branch_data;
  state.currentAgency = action.payload.data;
  state.currentAgency = action.payload.data;
  state.message = action.payload.message;
};

export {
  handleFetchAgenciesFulfilled,
  handleFetchMappingAgenciesFulfilled,
  handleFetchActiveAgenciesFulfilled,
  handleDeleteAgencyFulfilled,
  handleAddAgencyFulfilled,
  handleFetchAgencyByIdFulfilled,
  handleUpdateAgencyFulfilled,
};
